
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/payment-initiation/variable-recurring-payments/handling-failed-payments",
      function () {
        return require("private-next-pages/docs/payment-initiation/variable-recurring-payments/handling-failed-payments.mdx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/payment-initiation/variable-recurring-payments/handling-failed-payments"])
      });
    }
  